import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import withStyles from '@mui/styles/withStyles';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
// import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import SaveIcon from '@mui/icons-material/Save';
import withRouter from '../../../organisms/withRouter.js';
import PositiveButton from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import {renderTextField, renderSelect} from '../../../atoms/CustomPart.js';
import PaperPart from '../../../atoms/PaperPart.js';
import MenuItem from '@mui/material/MenuItem';
import {
  Typography,
} from '@mui/material';

const styles = (theme) => ({
  modal: {
    // display: 'absolute',
    // top: '10%',
    // left: '5%',
    // right: '5%',
    // bottom: '5%',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'none',
    // position: 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
  },
  paper: {
    backgroundColor: '#fafafa',
    border: '3px solid #fafafa',
    width: 'auto',
    height: 'auto',
    // idth: '95%',
    // overflow: 'auto',
    padding: '16pt',
    fontSize: '10pt',
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  button: {
    margin: '15px 10px 5px 10px',
  },

});

class Questionnaire extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commentBtnDisabled: true,
      tsTk: true,
      tyoSa: false,
      tenKen: false,
    };
  }

  closeModal = () => {
    console.log('close');
    this.props.doCloseModal();
  };

  setBtnDisable = (e, o) => {
    if (null === o || o.trim() === '') {
      this.setState({
        commentBtnDisabled: true,
      });
    } else {
      this.setState({
        commentBtnDisabled: false,
      });
    }
  };


  render() {
    const {classes, openState, handleClose, handleExec} = this.props;

    return (
      <Modal
        open={openState}
      >
        <PaperPart className={classes.paper}>
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>調査・点検箇所追加</Typography>
          <div style={{marginBottom: '20px'}} />
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid key="zigyoujo" item xs={3} sm={6}>
              <Field
                id="zigyoujo"
                name=""
                // variant="standard"
                component={renderSelect}
                className="fields"
                label="NW事業所"
                type="text"
                fullWidth
                required={true}
                validate={[
                ]}
                InputProps={{
                  readOnly: false,
                }}
              >
                <MenuItem value="">&nbsp;</MenuItem>
                <MenuItem value={5160}>{'広島北NWC'}</MenuItem>
                <MenuItem value={6120}>{'山口NWC'}</MenuItem>
              </Field>
            </Grid>
            <Grid key="tstkZigyoujo" item xs={3} sm={6}>
              <Field
                id="tstkZigyoujo"
                name=""
                // variant="standard"
                component={renderSelect}
                className="fields"
                label="調査機関事業所"
                type="text"
                fullWidth
                required={true}
                validate={[
                ]}
                InputProps={{
                  readOnly: false,
                }}
              >
                <MenuItem value="">&nbsp;</MenuItem>
                <MenuItem value={5160}>{'広島北支'}</MenuItem>
                <MenuItem value={6120}>{'山口支'}</MenuItem>
              </Field>
            </Grid>
            <Grid key="customerName" item xs={3} sm={12}>
              <Field
                id="customerName"
                name="customerName"
                variant="outlined"
                component={renderTextField}
                className="fields"
                label="お客さま名"
                fullWidth
                type="text"
                InputProps={{}}
                required={true}
                validate={[
                // validateRule.required,
                ]}
                onChange={this.setBtnDisable}
              ></Field>
            </Grid>
            <Grid key="dtNo" item xs={3} sm={12}>
              <Field
                id="dtNo"
                name="dtNo"
                variant="outlined"
                component={renderTextField}
                className="fields"
                label="電柱番号"
                fullWidth
                type="text"
                InputProps={{}}
                required={true}
                validate={[
                // validateRule.required,
                ]}
                onChange={this.setBtnDisable}
              ></Field>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >

            <Grid key="tstkType" item xs={3} sm={6}>
              <Field
                id="tstkType"
                name=""
                // variant="standard"
                component={renderSelect}
                className="fields"
                label="調査・点検データ区分"
                type="text"
                fullWidth
                required={true}
                validate={[
                ]}
                InputProps={{
                  readOnly: false,
                }}
              >
                <MenuItem value="">&nbsp;</MenuItem>
                <MenuItem value={1}>{'調査対象'}</MenuItem>
                <MenuItem value={2}>{'点検対象'}</MenuItem>
                <MenuItem value={3}>{'調査・点検対象'}</MenuItem>
              </Field>
            </Grid>
            <Grid key="blockNo" item xs={3} sm={6}>
              <Field
                id="blockNo"
                name="blockNo"
                variant="outlined"
                component={renderTextField}
                className="fields"
                label="ブロック番号"
                fullWidth
                type="text"
                InputProps={{}}
                required={false}
                validate={[
                // validateRule.required,
                ]}
                onChange={this.setBtnDisable}
              ></Field>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid key="tstkUserId" item xs={3} sm={6}>
              <Field
                id="tstkUserId"
                name="tstkUserId"
                // variant="standard"
                component={renderSelect}
                className="fields"
                label="担当者"
                type="text"
                fullWidth
                required={true}
                validate={[
                ]}
                InputProps={{
                  readOnly: false,
                }}
              >
                <MenuItem value="">&nbsp;</MenuItem>
                <MenuItem value={100001}>{'田中　さくら'}</MenuItem>
                <MenuItem value={100002}>{'田中　さくら２'}</MenuItem>
              </Field>
            </Grid>
            <Grid key="tstkMonth" item xs={3} sm={6}>
              <Field
                id="tstkMonth"
                name="tstkMonth"
                // variant="standard"
                component={renderSelect}
                className="fields"
                label="実施年月"
                type="text"
                fullWidth
                required={true}
                validate={[
                ]}
                InputProps={{
                  readOnly: false,
                }}
              >
                <MenuItem value="">&nbsp;</MenuItem>
                <MenuItem value={9}>{'2027／09'}</MenuItem>
                <MenuItem value={10}>{'2027／10'}</MenuItem>
                <MenuItem value={11}>{'2027／11'}</MenuItem>
                <MenuItem value={12}>{'2027／12'}</MenuItem>
                <MenuItem value={1}>{'2028／01'}</MenuItem>
                <MenuItem value={2}>{'2028／02'}</MenuItem>
                <MenuItem value={3}>{'2028／03'}</MenuItem>
              </Field>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            <Grid key="comment" item xs={3} sm={12}>
              <Field
                id="comment"
                name="comment"
                multiline={true}
                rows={5}
                variant="outlined"
                component={renderTextField}
                className="fields"
                label="メモ"
                fullWidth
                type="text"
                InputProps={{}}
                required={false}
                validate={[
                // validateRule.required,
                ]}
              ></Field>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="center"
            alignItems="flex-end"
            spacing={1}
          >
            <Grid key="btnCreateComment" item >
              <PositiveButton
                id="btnCreateComment"
                variant="contained"
                startIcon={<SaveIcon />}
                size="middium"
                disabled={this.state.commentBtnDisabled}
                // onClick={handleExec}
                onClick={handleExec}
              >
                <span>確定</span>
              </PositiveButton>
            </Grid>
            <Grid key="keyModalCloseBtn" item >
              <NegativeButton
                id="btnCloser"
                variant="contained"
                // startIcon={<KeyboardReturnIcon />}
                size="middium"
                onClick={handleClose}
              >
                <span>キャンセル</span>
              </NegativeButton>
            </Grid>
          </Grid>
        </PaperPart>
      </Modal>
    );
  }
}

Questionnaire.propTypes = {
  classes: PropTypes.object,
  modalInfo: PropTypes.object,
  content: PropTypes.object,
  doCloseModal: PropTypes.func,
  handleClose: PropTypes.func,
  handleExec: PropTypes.func,
  openState: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  modalInfo: state.common.modalInfo,
});

const mapDispatchToProps = {
  doCloseModal: commonOperations.doCloseModal,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Questionnaire)),
);
